module.exports = __webpack_public_path__ + "8f1aacfb58d0d711675a5fe61de3d65e.png";